var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"transition-anim"}},[_c('router-view',{staticClass:"view"})],1),(_vm.bannerStatus)?_c('notification-banner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }